import Vue from "vue";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import {
  BCollapse,
  BButton,
  BCard,
  BFormInput,
  BInputGroup,
  BBreadcrumb,
  BFormFile,
  BAlert,
  BTable,
  BPagination,
  BFormDatepicker,
  BDropdown,
  BDropdownItem,
  BDropdownItemButton,
  BCardHeader,
  BCardBody,
  BModal,
  VBModal,
  BSpinner,
  BToast,
  BVToastPlugin,
  BFormGroup,
  BFormRadioGroup,
  BFormRadio,
  BCardText,
  BCol,
  BRow,
  BCardImg,
  BCardGroup,
  BInputGroupAppend,
  BBadge,
  BTabs,
  BTab,
  BFormCheckbox
} from "bootstrap-vue";

Vue.directive("b-modal", VBModal);
Vue.directive("b-toast", BToast);
Vue.use(BVToastPlugin);

Vue.component("b-collapse", BCollapse);
Vue.component("b-col", BCol);
Vue.component("b-row", BRow);
Vue.component("b-button", BButton);
Vue.component("b-card", BCard);
Vue.component("b-form-input", BFormInput);
Vue.component("b-input-group", BInputGroup);
Vue.component("b-breadcrumb", BBreadcrumb);
Vue.component("b-form-file", BFormFile);
Vue.component("b-alert", BAlert);
Vue.component("b-table", BTable);
Vue.component("b-form-datepicker", BFormDatepicker);
Vue.component("b-pagination", BPagination);
Vue.component("b-dropdown", BDropdown);
Vue.component("b-dropdown-item", BDropdownItem);
Vue.component("b-dropdown-item-button", BDropdownItemButton);
Vue.component("b-card-header", BCardHeader);
Vue.component("b-card-body", BCardBody);
Vue.component("b-card-text", BCardText);
Vue.component("b-card-img", BCardImg);
Vue.component("b-card-group", BCardGroup);
Vue.component("b-modal", BModal);
Vue.component("b-spinner", BSpinner);
Vue.component("b-form-group", BFormGroup);
Vue.component("b-form-radio-group", BFormRadioGroup);
Vue.component("b-form-radio", BFormRadio);
Vue.component("b-input-group-append", BInputGroupAppend);
Vue.component("b-badge", BBadge);
Vue.component("b-tabs", BTabs);
Vue.component("b-tab", BTab);
Vue.component("b-form-checkbox", BFormCheckbox);
